// C7 · الأقسام (departments) — per-screen i18n namespace. Merged into the shared
// messages at load time (i18n.ts require.context), so keys resolve as
// $t('departments.<key>'). Full ar/en parity.
module.exports = {
  ar: {
    departments: {
      title: 'الأقسام',
      loading: 'جارِ تحميل الأقسام...',
      error: 'حدث خطأ أثناء تحميل الأقسام',
      empty: 'لا توجد أقسام مسجّلة',
      searchPlaceholder: 'ابحث باسم القسم أو المدير...',
      addBtn: 'إضافة قسم',
      filterAll: 'الكل',
      filterActive: 'نشط',
      filterSuspended: 'موقوف',
      colDept: 'القسم',
      colEmployees: 'عدد الموظفين',
      colManager: 'المدير / المسؤول',
      colStatus: 'الحالة',
      noManager: 'غير محدّد',
      statusActive: 'نشط',
      statusSuspended: 'موقوف',
      actEdit: 'تعديل',
      actSuspend: 'إيقاف',
      actActivate: 'تفعيل',
      summary: '{count} أقسام — {active} نشطة و{suspended} موقوف',
      totalEmployees: 'إجمالي الموظفين الموزّعين: {n}',
      formCreateTitle: '➕ إضافة قسم جديد',
      formEditTitle: '✏️ تعديل القسم',
      defaultActiveTag: 'نشط افتراضيًا',
      fieldName: 'اسم القسم',
      fieldNamePlaceholder: 'مثال: خدمة العملاء',
      fieldManager: 'المدير / المسؤول',
      fieldManagerPlaceholder: 'اسم المدير (اختياري)',
      fieldStatus: 'الحالة',
      save: '💾 حفظ القسم',
      cancel: 'إلغاء',
      nameRequired: 'اسم القسم مطلوب',
      saveError: 'تعذّر حفظ القسم، حاول مرة أخرى',
      filter: {
        button: 'الفلاتر',
        clear: 'مسح الفلاتر',
        done: 'تم',
      },
      saved: {
        created: 'تم إضافة القسم «{name}»',
        edited: 'تم تعديل القسم «{name}»',
      },
      delete: {
        button: 'حذف',
        hint: 'حذف ناعم — القسم يختفي من القوائم، والبيانات المرتبطة بيه تفضل محفوظة',
        yes: 'نعم، احذف',
        cancel: 'إلغاء',
        deleting: 'جارٍ الحذف…',
        done: 'تم حذف القسم «{name}»',
        errors: {
          hasEmployees: 'مش ممكن حذف القسم وفيه {n} موظف — انقلهم لقسم تاني الأول وبعدين احذفه',
          notFound: 'القسم مش موجود (يمكن اتحذف قبل كده) — حدّث الصفحة',
          forbidden: 'مش مسموح لك بحذف القسم دا',
          network: 'فيه مشكلة في الشبكة — جرّب تاني',
          generic: 'تعذّر حذف القسم — جرّب تاني',
        },
      },
      noteLabel: 'ملاحظة',
      note: 'تظهر هذه الأقسام كاختيار لـ«القسم» عند إضافة موظف. يبقى القسم الموقوف مرتبطاً بالموظفين الحاليين لكنه لا يظهر كاختيار جديد.',
    },
  },
  en: {
    departments: {
      title: 'Departments',
      loading: 'Loading departments...',
      error: 'Failed to load departments',
      empty: 'No departments yet',
      searchPlaceholder: 'Search by department or manager...',
      addBtn: 'Add department',
      filterAll: 'All',
      filterActive: 'Active',
      filterSuspended: 'Suspended',
      colDept: 'Department',
      colEmployees: 'Employees',
      colManager: 'Manager',
      colStatus: 'Status',
      noManager: 'Unassigned',
      statusActive: 'Active',
      statusSuspended: 'Suspended',
      actEdit: 'Edit',
      actSuspend: 'Suspend',
      actActivate: 'Activate',
      summary: '{count} departments — {active} active, {suspended} suspended',
      totalEmployees: 'Total distributed employees: {n}',
      formCreateTitle: '➕ Add new department',
      formEditTitle: '✏️ Edit department',
      defaultActiveTag: 'Active by default',
      fieldName: 'Department name',
      fieldNamePlaceholder: 'e.g. Customer Service',
      fieldManager: 'Manager',
      fieldManagerPlaceholder: 'Manager name (optional)',
      fieldStatus: 'Status',
      save: '💾 Save department',
      cancel: 'Cancel',
      nameRequired: 'Department name is required',
      saveError: 'Could not save the department, try again',
      filter: {
        button: 'Filters',
        clear: 'Clear filters',
        done: 'Done',
      },
      saved: {
        created: 'Department “{name}” was added',
        edited: 'Department “{name}” was updated',
      },
      delete: {
        button: 'Delete',
        hint: 'Soft delete — the department leaves every list; linked data is kept',
        yes: 'Yes, delete',
        cancel: 'Cancel',
        deleting: 'Deleting…',
        done: 'Department “{name}” was deleted',
        errors: {
          hasEmployees: 'Cannot delete a department with {n} employee(s) — move them to another department first',
          notFound: 'That department no longer exists (it may already be deleted) — refresh the page',
          forbidden: 'You are not allowed to delete this department',
          network: 'Network problem — please try again',
          generic: 'Could not delete the department — please try again',
        },
      },
      noteLabel: 'Note',
      note: 'These departments appear as the "Department" option when adding an employee. A suspended department stays on current employees but is not offered as a new choice.',
    },
  },
};
